// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__30qJf","col":"styles_col__3D4Sa"};